import { IChungChiChungNhan } from "../../../model/response/chung-chi-chung-nhan/IChungChiChungNhan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChungChiChungNhanActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IChungChiChungNhan[],
    LOAD_ERROR: "",

    SAVE_START: {} as IChungChiChungNhan,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: {} as IChungChiChungNhan | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SHOW_CHI_TIET_MODAL: {} as IChungChiChungNhan,
    CLOSE_CHI_TIET_MODAL: undefined,
}

export const eChungChiChungNhanActionIds = generateActionTypeIds(eChungChiChungNhanActionsObj, "CHUNG_CHI_CHUNG_NHAN");
export type IChungChiChungNhanActionTypes = IGenericActionType<typeof eChungChiChungNhanActionsObj, "CHUNG_CHI_CHUNG_NHAN">;
